import {
  Navigate,
  Outlet
} from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

export const AdminRoute = () => {

  const { isProjectAdmin, isTestToolAdmin } = useSelector((state: RootState) => state.authReducer);

  return (
    isProjectAdmin || isTestToolAdmin
      ? <Outlet />
      : <Navigate to="/" />
  )
};